<template>
  <div class="regist-new">
    <div class="backgroundImage"></div>
    <h3 class="title">验证手机号</h3>
    <div class="form">
      <div class="form-item">
        <van-field class="input" v-model.trim="phoneNumber" name="phoneNumber" placeholder="手机号" />
      </div>
      <div class="form-item">
        <van-field
          class="input"
          v-model.trim="checkCode"
          name="code"
          placeholder="图像验证码"
          maxlength="10"
        ></van-field>
        <img class="code-img" @click="initCodeImg" style="height: 28px" :src="codeUrl" alt="" />
      </div>
      <div class="form-item">
        <van-field class="input" v-model.trim="code" name="code" placeholder="短信验证码" maxlength="10"></van-field>
        <div class="send-code">
          <span v-if="!showCount" @click="handleSendCode">发送验证码</span>
          <van-count-down @finish="showCount = false" v-else :time="time" format="ss秒" style="color: #8c8c8c" />
        </div>
      </div>
      <div class="submit" :class="{active: active}" @click="onSubmit">下一步</div>
    </div>
  </div>
</template>

<script>
import {checkPhoneNumber} from '@/ultis'
import {getCode, checkPhone, verifyCode, getCodeImg, verifyPhone} from '@/api'
export default {
  data() {
    return {
      phoneNumber: '',
      code: '',
      checkCode: '',
      checkCodeSessionId: '',
      codeUrl: '',
      time: 60 * 1000,
      showCount: false,
      active: false
    }
  },
  created() {
    this.initCodeImg()
  },
  watch: {
    phoneNumber(newV) {
      this.handleActiveVerify()
    },
    checkCode(newV) {
      this.handleActiveVerify()
    }
  },
  methods: {
    handleActiveVerify() {
      if (this.phoneNumber && this.checkCode) {
        this.active = true
      } else {
        this.active = false
      }
    },
    // 获取图形验证码
    initCodeImg() {
      getCodeImg().then(res => {
        const {checkCodeImageData, checkCodeSessionId} = res.data
        this.checkCodeSessionId = checkCodeSessionId
        this.codeUrl = checkCodeImageData
      })
    },
    async onSubmit() {
      if (!this.active) return
      if (!checkPhoneNumber(this.phoneNumber)) {
        return this.$Toast.fail('输入正确的手机号')
      }
      if (!this.code) {
        return this.$Toast.fail('请输短信验证码')
      }
      if (!this.checkCode) {
        return this.$Toast.fail('请输图形验证码')
      }
      const params = {
        phone: this.phoneNumber,
        smsCode: this.code,
        checkCodeSessionId: this.checkCodeSessionId,
        checkCode: this.checkCode
      }
      const res = await checkPhone({phone: this.phoneNumber})
      if (res.data.code === 0) {
        verifyCode(params).then(res => {
          const {verifyId} = res.data
          // 判断是否加入过机构
          verifyPhone({verifyId}).then(res => {
            const exist = res.data.exist
            if (exist) {
              const hasRegistOrgLists = res.data.orgList
              localStorage.setItem('hasRegistOrgLists', JSON.stringify(hasRegistOrgLists))
              this.$router.push({
                path: '/registHasOrgs',
                query: {
                  verifyId
                }
              })
            } else {
              this.$router.push({
                path: '/registChooseOrg',
                query: {
                  verifyId,
                  phone: this.phoneNumber
                }
              })
            }
          })
        })
      } else {
        this.$Toast.fail(res.data.msg)
      }
    },
    // 发短信
    async handleSendCode() {
      if (!checkPhoneNumber(this.phoneNumber)) {
        return this.$Toast.fail('输入正确的手机号')
      }
      const res = await checkPhone({phone: this.phoneNumber})
      if (res.data.code === 0) {
        await getCode({phone: this.phoneNumber})
        this.showCount = true
      } else {
        this.$Toast.fail(res.data.msg)
      }
    }
  }
}
</script>

<style lang="scss">
.regist-new {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  font-size: 14px;
  background: #fff;
  .backgroundImage {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 134px;
    background: linear-gradient(359deg, #ffffff 0%, #ddeafb 100%);
  }
  .title {
    margin-top: 134px;
    font-size: 20px;
    font-weight: 500;
    color: #000;
  }
  .form {
    margin-top: 28px;
    width: 100%;
    padding: 0 36px;
    box-sizing: border-box;
    .form-item {
      position: relative;
      margin-bottom: 14px;
      .input {
        background-color: #f5f7fa;
        border-radius: 50px;
        input {
          &::placeholder {
            color: #8c8c8c;
          }
        }
      }
      .code-img {
        position: absolute;
        right: 14px;
        top: 8px;
      }
      .send-code {
        position: absolute;
        right: 14px;
        top: 11px;
        color: #8c8c8c;
        span {
          font-size: 13px;
        }
      }
    }
    .submit {
      margin-top: 24px;
      width: 100%;
      height: 44px;
      color: #fff;
      text-align: center;
      line-height: 44px;
      background: rgba(#007aff, 0.35);
      border-radius: 22px;
      &.active {
        background: rgba(#007aff, 1);
      }
    }
  }
}
</style>
